import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Button from "components/Forms/CustomButtons/ButtonTS";
import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmUploadCompleteProps {
  isUploading: boolean;
  modalOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmUploadComplete({
  isUploading,
  modalOpen,
  onClose,
  onConfirm,
}: ConfirmUploadCompleteProps) {
  const { t } = useTranslation("modals");

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={() => {
        onClose();
      }}
      disableBackdropClick
    >
      <DialogTitle>
        {t("want-proceed")}
        <Button
          justIcon
          simple
          color="tumblr"
          round
          size="sm"
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent>{t("if-you-proceed")}</DialogContent>

      <DialogActions>
        <Button disabled={isUploading} color="tumblr" simple onClick={onClose}>
          {t("cancel")}
        </Button>

        <Button disabled={isUploading} color="primary" onClick={onConfirm}>
          {t("proceed")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
